if (!customElements.get('drbo-cart-service-offer')) {
  const pendingVariants = new Set();
  customElements.define('drbo-cart-service-offer', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.form.addEventListener('submit', event => this.addService(event), { signal: this.events.signal });
      const section = this.closest('[data-section-type="cart-template"]');
      const subtotal = section?.querySelector('.js-cart-subtotal');
      if (subtotal) {
        this.id = `drbo-cart-service-${section.dataset.sectionId}`;
        this.prompt = document.createElement('div');
        this.prompt.className = 'drbo-cart-service-prompt';
        const link = document.createElement('a');
        link.href = `#${this.id}`;
        link.textContent = this.dataset.promptLabel;
        link.addEventListener('click', event => {
          event.preventDefault();
          this.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          this.button.focus({ preventScroll: true });
        }, { signal: this.events.signal });
        this.prompt.append(link);
        subtotal.append(this.prompt);
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.prompt?.remove();
    }

    async addService(event) {
      event.preventDefault();
      const variantId = Number(this.dataset.serviceVariant);
      if (!variantId || pendingVariants.has(variantId)) return;
      pendingVariants.add(variantId);
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.status.hidden = true;
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { cache: 'no-store' });
        if (!response.ok) throw new Error(this.dataset.errorLabel);
        const cart = await response.json();
        if (cart.items.some(item => Number(item.product_id) === Number(this.dataset.serviceProduct))) {
          this.hidden = true;
          this.prompt?.remove();
          window.themeCore?.EventBus?.emit('cart:refresh');
          return;
        }
        const eligibleIds = new Set(this.dataset.eligibleProducts.split(',').filter(Boolean).map(Number));
        if (!cart.items.some(item => eligibleIds.has(Number(item.product_id)))) {
          throw new Error(this.dataset.ineligibleLabel);
        }
        const sectionIds = [...new Set([...document.querySelectorAll('[data-section-type="cart-template"]')].map(section => section.dataset.sectionId).filter(Boolean))].slice(0, 5);
        const api = window.themeCore?.CartApi;
        if (api?.makeRequest && api.actions?.ADD_TO_CART) {
          await api.makeRequest(api.actions.ADD_TO_CART, { id: variantId, quantity: 1, noOpen: true }, sectionIds.join(','));
        } else {
          const result = await fetch(`${this.form.action}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!result.ok) {
            const failure = await result.json().catch(() => ({}));
            throw new Error(failure.description || this.dataset.errorLabel);
          }
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        if (this.isConnected) {
          this.button.textContent = this.dataset.addedLabel;
          this.button.disabled = true;
        }
      } catch (error) {
        if (this.isConnected) {
          this.status.textContent = error.description || error.message || this.dataset.errorLabel;
          this.status.hidden = false;
          this.button.disabled = false;
          this.button.textContent = this.dataset.addLabel;
        }
      } finally {
        pendingVariants.delete(variantId);
        this.removeAttribute('aria-busy');
      }
    }
  });
}
